import { useEffect, useReducer, useState } from 'react'
import { useModalBox } from '../../../presentation/contexts'

import { fetchConsumption, fetchPeriods } from '../../usecases/billing'

import { consumptionModel } from '../../../domain/models/billing-models'
import Billing from '../../../presentation/pages/my-data/billing'
import { formatDate } from '../../../presentation/utils'

const BilingFactory = () => {
  const [consumption, setConsumption] = useState<consumptionModel[]>([])
  const [consumptionOptions, setconsumptionOptions] = useState<string[]>([])
  const [period, setPeriod] = useState<string>('')
  const { modalBox } = useModalBox()
  const handleHistoryOptionClick = (modalBody: any) => {
    modalBox(modalBody, 'Histórico', '52%', '52%')
  }
  const initialState: any = []
  const reduceUser = (state: any, action: any) => {
    switch (action.type) {
      case 'add':
        return [...state, action.newItem]
      default:
        return []
    }
  }
  const [consumptionAux, dispatch] = useReducer(reduceUser, initialState)
  useEffect(() => {
    ;(async () => {
      const loadDateOptions = await fetchPeriods().load()
      const loadConsumption = await fetchConsumption(period).load()
      setConsumption(loadConsumption)
      setconsumptionOptions(loadDateOptions)
      dispatch({ type: 'clean' })
      for (let index = 0; index < loadConsumption.length; index++) {
        dispatch({ type: 'add', newItem: loadConsumption[index] })
        if (index === 2) break
      }
    })()
  }, [period])
  const consumptionBody = consumptionAux.map((item) => {
    return (
      <div>
        <span>{formatDate(item.dataConsumo)}</span>
        <span>{item.nomePaciente}</span>
        <span>{item.demandaServico}</span>
      </div>
    )
  })

  const consumptionTable = (
    <table>
      <th>Data</th>
      <th>Paciente</th>
      <th>Serviço</th>
      {consumption.map((item) => {
        return (
          <tr>
            <td>{formatDate(item.dataConsumo)}</td>
            <td>{item.nomePaciente}</td>
            <td>{item.demandaServico}</td>
          </tr>
        )
      })}
    </table>
  )
  return (
    <Billing
      consumptionBody={consumptionBody}
      setPeriods={setPeriod}
      handleConsumption={handleHistoryOptionClick}
      consumptionTable={consumptionTable}
      consumptionPeriods={consumptionOptions}
    />
  )
}
export default BilingFactory
